import React from 'react';
import { useSelector } from 'react-redux'
import TargetHandle from './TargetHandle';
import SourceHandle from './SourceHandle';
import Iconify from '../../../common/iconify/Iconify';
import { Tooltip } from '@mui/material';
import { EXCLUDE_FOR_SIDEBAR_IPTS } from '../../constant';
import { getNodeType } from '../registry';

/** Build the compact badges for a node's configured properties */
function NodeBadges({ data, keysToExclude }) {
    const hasFM = data?.filterKey || data?.mandatory
    const hasInput = !keysToExclude.includes('inputMode') && data?.inputMode
    const hasRegex = !keysToExclude.includes('inputRegex') && data?.inputRegex
    const hasMin  = !keysToExclude.includes('minSize') && data?.minSize > 0
    const hasMax  = !keysToExclude.includes('maxSize') && data?.maxSize > 0
    if (!hasFM && !hasInput && !hasRegex && !hasMin && !hasMax) return null

    return (
        <div className="node-badges">
            {data?.mandatory && <span className="node-badge node-badge-required">Required</span>}
            {hasInput && <span className="node-badge">Input: {data.inputMode}</span>}
            {hasRegex && <span className="node-badge">Regex</span>}
            {hasMin && <span className="node-badge">Min: {data.minSize}</span>}
            {hasMax && <span className="node-badge">Max: {data.maxSize}</span>}
            {data?.filterKey && <span className="node-badge node-badge-filter">Filter: {data.filterKey}</span>}
        </div>
    )
}

function CommonNode({ data, icon, disableStyle, disableTargetHandle, disableSourceHandle }) {
    const lang = useSelector(state => state.lang.ui.lang);
    const keysToExclude = EXCLUDE_FOR_SIDEBAR_IPTS?.[data?.type] || []
    const config = getNodeType(data?.type)
    const color = config?.color || '#666'
    const label = config?.label || data?.type
    const questionText = data?.question?.[lang]

    // full tooltip with all language variants
    const questionTooltip = data?.question
        ? Object.entries(data.question).map(([k, v]) => `${k}: ${v}`).join(' · ')
        : ''

    return (
        <div className={`callflow-node ${data?.status == 'D' && 'disabled-node'}`}>
            {/* Colored header: small icon + question text */}
            <div className="node-type-header" style={{ backgroundColor: color }}>
                <Iconify icon={icon} sx={{ width: 14, height: 14, color: 'rgba(255,255,255,0.9)', flexShrink: 0 }} />
                <Tooltip title={<span style={{ fontSize: 12 }}>{questionTooltip}</span>} placement="bottom">
                    <span className="node-type-question">{questionText || label}</span>
                </Tooltip>
            </div>
            <div className="callflow-body">
                {!disableTargetHandle && <TargetHandle id={data?.id} />}
                <NodeBadges data={data} keysToExclude={keysToExclude} />
                {!disableSourceHandle && <SourceHandle id={data?.id} />}
            </div>
        </div>
    );
}

export default React.memo(CommonNode)
